import mbiLogoPath from '../../assets/mbi-logo-white.png';

const useStyles = ({ height }) => ({
  header: {
    width: '100vw',
    height: `${height}px`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    width: '100%',
    textAlign: 'center',
  },
});

const MobileMenuPageHeader = ({ height }) => {
  const styles = useStyles({ height });

  return (
    <header style={styles.header}>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <img src={mbiLogoPath} alt="MBI logo" />
      </div>
      <span style={styles.title}>MA Broadband App</span>
    </header>
  );
};

export default MobileMenuPageHeader;
